export enum SidePanelContent {
  GENERAL = 'general',
  FILES = 'files',
  NEW_VERSION = 'new-version',
  GALLERY = 'gallery',
  DESCRIPTION = 'description',
}
